import { RootStore } from 'Portals/Customer/stores'

import { OrderTable } from './OrderTable'

export class OrderStore {
	table: OrderTable

	constructor(public rootStore: RootStore) {
		this.table = new OrderTable(rootStore)
	}
}
